
import { MapTo } from '@adobe/aem-react-editable-components';
import IndustryReviews, { IndustryReviewsEditConfig } from './IndustryReviews';

export default MapTo('cob-corp-acquisition/components/creditonebank/industry-reviews')(IndustryReviews, IndustryReviewsEditConfig);
        